<template>
	<div class="info-component" :style="{background:bgColor,borderColor:borderColor}">
		<div v-if="file&&file.length!=0" class="audio">
			<div  v-for="(item,index) in file" :key='index'>
				<m-audio v-if='item.type==4' :src="item.annexName"></m-audio>
			</div>
		</div>
		<div v-if="content" class="content">{{content}}</div>
		<div v-if="file&&file.length!=0" class="img-list">
			<div class="img" v-for="(item,index) in file" :key='index'>
				<el-image v-if='item.type==1' style="width: 100px; height: 100px" :src="item.annexName" :preview-src-list="imgList"></el-image>
			</div>
		</div>
	</div>
</template>

<script>
	// import audioM from './audio.vue'
	export default {
		props: ['file', 'content','bgColor','borderColor'],
		data() {
			return {
				imgList:[]
			}
		},
		created() {
			if(this.file&&this.file.length!=0){
				this.file.map(item=>{
					if(item.type==1){
						this.imgList.push(item.annexName)
					}
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.info-component {
		// background: #e7f6fb;
		margin: 10px 0;
		border-radius: 10px;
		border: 1px;
		padding: 20px;
		box-sizing: border-box;

		.audio {
			margin-bottom: 10px;
		}

		.content {
			margin-bottom: 10px;
		}
		.img-list{
			display: flex;
			.img{
				margin-right: 10px;
			}
		}
	}
</style>
